/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserRole { 
    id?: number;
    creationTime?: string;
    creatorUserId?: number | null;
    tenantId?: number | null;
    userId?: number;
    roleId?: number;
}

